import { BASE_FONT_SIZE, BORDERS, COLORS } from '@alto/design-library-tokens';
import { Icon } from '@alto/design-system';
import React from 'react';
import { Dimensions } from 'react-native';
import { Calendar } from 'react-native-calendars';

export type Date = {
  year: number;
  month: number;
  day: number;
  timestamp: number;
  dateString: string;
};
type DatePickerProps = React.ComponentProps<typeof Calendar>;

const THEME = {
  calendarBackground: COLORS.PALETTE.GREYSCALE.WHITE,
  textDayFontSize: BASE_FONT_SIZE / Dimensions.get('window').fontScale,
  textSectionTitleColor: COLORS.PALETTE.GREYSCALE.DARKER,
  selectedDayBackgroundColor: COLORS.TEXT_COLORS.PRIMARY,
  selectedDayTextColor: COLORS.PALETTE.GREYSCALE.WHITE,
  todayTextColor: COLORS.TEXT_COLORS.BLACK,
  todayBackgroundColor: COLORS.PALETTE.GREYSCALE.LIGHTER,
  dayTextColor: COLORS.TEXT_COLORS.BLACK,
  textDisabledColor: COLORS.PALETTE.GREYSCALE.DEFAULT,
  dotColor: COLORS.TEXT_COLORS.PRIMARY,
  selectedDotColor: COLORS.PALETTE.GREYSCALE.WHITE,
  arrowColor: COLORS.TEXT_COLORS.PRIMARY,
  monthTextColor: COLORS.TEXT_COLORS.BLACK,
  'stylesheet.calendar.main': {
    container: {
      borderRadius: BORDERS.RADIUS.XS.value,
      borderWidth: 1,
      borderColor: COLORS.PALETTE.GREYSCALE.LIGHTER,
    },
  },
};

const renderArrow = (direction: 'left' | 'right') => (
  <Icon name={direction === 'left' ? 'chevronleft' : 'chevronright'} />
);

export const DatePicker = (props: DatePickerProps) => {
  return (
    <Calendar
      hideExtraDays
      renderArrow={renderArrow}
      theme={THEME}
      {...props}
      testID="datepicker"
    />
  );
};
